import { ReactComponent as SvgChatGpt } from './ChatGPT.svg.es.js';
import { ReactComponent as SvgDiscord } from './Discord.svg.es.js';
import { ReactComponent as SvgFacebook } from './Facebook.svg.es.js';
import { ReactComponent as SvgGitHub } from './GitHub.svg.es.js';
import { ReactComponent as SvgGoogle } from './Google.svg.es.js';
import { ReactComponent as SvgInstagram } from './Instagram.svg.es.js';
import { ReactComponent as SvgLinkedin } from './Linkedin.svg.es.js';
import { ReactComponent as SvgReddit } from './Reddit.svg.es.js';
import { ReactComponent as SvgXTwitter } from './X-Twitter.svg.es.js';
import { ReactComponent as SvgYoutube } from './Youtube.svg.es.js';

const SvgSocialIcons = {
    'Social/ChatGPT': SvgChatGpt,
    'Social/Discord': SvgDiscord,
    'Social/Facebook': SvgFacebook,
    'Social/GitHub': SvgGitHub,
    'Social/Google': SvgGoogle,
    'Social/Instagram': SvgInstagram,
    'Social/Linkedin': SvgLinkedin,
    'Social/Reddit': SvgReddit,
    'Social/X-Twitter': SvgXTwitter,
    'Social/Youtube': SvgYoutube
};

export { SvgSocialIcons };
//# sourceMappingURL=index.es.js.map
